'use strict';

import accordion from 'plugins/accordion';

const SELECTOR = '.js-accordion';

export function init() {
    const elements = document.querySelectorAll(SELECTOR);
    const NEXT_SELECTOR = '[data-donation-accordion-next-selector]';

    if (!elements.length) {
        return false;
    }

    elements.forEach(element => {
        accordion(element);
    });

    const nextSelectors = document.querySelectorAll(NEXT_SELECTOR);

    nextSelectors.forEach(selector => {
        selector.addEventListener('click', event => {
            const nextSelector = event
                .currentTarget
                .dataset

            if (!nextSelector) {
                return;
            }

            const nextElement = document.querySelector(nextSelector);

            if (!nextElement) {
                return;
            }

            nextElement.click();
        }, false);
    });
}

export default { init }

